import React, { useEffect, useState } from 'react';
import { Timer } from 'lucide-react';
export function CountdownBar() {
  // Start at 45 minutes (2700 seconds)
  const [timeLeft, setTimeLeft] = useState(2700);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <div className="sticky top-0 z-50 w-full bg-emergency text-white py-2 px-4 shadow-md" data-id="element-12">
      <div className="max-w-md mx-auto flex items-center justify-center gap-2 text-sm font-bold text-center" data-id="element-13">
        <Timer className="w-4 h-4 animate-pulse" data-id="element-14" />
        <span data-id="element-15">
          ¡OFERTA POR TIEMPO LIMITADO! El descuento termina en:{' '}
          {minutes.toString().padStart(2, '0')}:
          {seconds.toString().padStart(2, '0')}
        </span>
      </div>
    </div>;
}